<template>
    <!-- 颈部功能六项数据区域。 -->
    <div class="neck-assess-data">
        <!-- 颈椎前屈数据。 -->
        <neck-data-item v-if="neckInfo.headForward" :item="neckInfo.headForward"></neck-data-item>
        <!-- 颈椎后伸数据。 -->
        <neck-data-item v-if="neckInfo.headBackward" :item="neckInfo.headBackward"></neck-data-item>
        <!-- 颈椎左侧屈数据。 -->
        <neck-data-item v-if="neckInfo.leftBend" :item="neckInfo.leftBend"></neck-data-item>
        <!-- 颈椎右侧屈数据。 -->
        <neck-data-item v-if="neckInfo.rightBend" :item="neckInfo.rightBend"></neck-data-item>
        <!-- 颈椎左旋转数据。 -->
        <neck-data-item v-if="neckInfo.leftSpin" :item="neckInfo.leftSpin"></neck-data-item>
        <!-- 颈椎右旋转数据。 -->
        <neck-data-item v-if="neckInfo.rightSpin" :item="neckInfo.rightSpin"></neck-data-item>
    </div>
</template>

<script>
// 引入颈部功能结论查询。
import { findBsNeckConclusion } from '@/assets/js/apolloGql.js'
// 复用现有角度数据卡片。
import NeckDataItem from '@/components/common/NeckDataItem'

// 导出颈部功能数据组件。
export default {
    // 注册颈部数据卡片。
    components: {
        // 颈部单项数据卡片。
        NeckDataItem,
    },
    // 声明报告基础信息。
    props: {
        // 当前报告信息。
        massInfo: Object,
    },
    // 初始化组件状态。
    data() {
        // 返回六项数据状态。
        return {
            // 保存接口返回的颈部数据。
            neckInfo: {},
        }
    },
    // 组件挂载后查询颈部数据。
    mounted() {
        // 加载六项颈部功能数据。
        this.loadNeckInfo()
    },
    // 声明组件方法。
    methods: {
        // 查询颈部功能数据。
        loadNeckInfo() {
            // 发起 GraphQL 查询。
            this.$apollo.query({
                // 使用颈部功能查询文档。
                query: findBsNeckConclusion,
                // 设置查询参数。
                variables: {
                    // 当前会员 ID。
                    memberId: this.massInfo.memberId,
                    // 当前扫描 ID。
                    scanId: this.massInfo.scanId,
                    // 当前扫描时间。
                    scanTime: String(this.massInfo.createTime),
                },
                // 始终读取最新数据。
                fetchPolicy: 'network-only',
            }).then((res) => {
                // 提取颈部功能响应。
                const result = res.data.bsNeckConclusion
                // 仅处理成功响应。
                if (result && result.code === 200 && result.data) {
                    // 保存六项颈部功能数据。
                    this.neckInfo = result.data.neckInfo || {}
                }
            })
        },
    },
}
</script>

<style lang="less" scoped>
/* 颈部功能数据外层样式。 */
.neck-assess-data {
    padding: 0 10px;
}
</style>
